import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import './HomePage.css';

const HomePage: React.FC = () => {
  const [currentTime, setCurrentTime] = useState(new Date());
  const [greeting, setGreeting] = useState('');

  useEffect(() => {
    const timer = setInterval(() => {
      setCurrentTime(new Date());
    }, 1000);

    const hour = new Date().getHours();
    if (hour < 12) {
      setGreeting('Доброе утро');
    } else if (hour < 18) {
      setGreeting('Добрый день');
    } else {
      setGreeting('Добрый вечер');
    }

    return () => clearInterval(timer);
  }, []);

  const formatTime = (date: Date) => {
    return date.toLocaleTimeString('ru-RU', {
      hour: '2-digit',
      minute: '2-digit',
      second: '2-digit'
    });
  };

  const formatDate = (date: Date) => {
    return date.toLocaleDateString('ru-RU', {
      weekday: 'long',
      year: 'numeric',
      month: 'long',
      day: 'numeric'
    });
  };

  return (
    <div className="home-page">
      <div className="page">
        <div className="page-header">
          <div className="welcome-header">
            <h1 className="page-title">{greeting}! 👋</h1>
            <p className="page-subtitle">Твой персональный планер для гармоничной жизни</p>
          </div>
          
          <div className="time-widget">
            <div className="current-time">{formatTime(currentTime)}</div>
            <div className="current-date">{formatDate(currentTime)}</div>
          </div>
        </div>
        
        <div className="page-content">
          <div className="welcome-section">
            <h2 className="section-title">Начни свой путь к лучшей версии себя</h2>
            <p className="welcome-text">
              Этот планер создан специально для современных девушек, которые хотят организовать свою жизнь, 
              следить за здоровьем и развиваться каждый день.
            </p>
          </div>

          <div className="quick-access">
            <h3 className="section-title">Быстрый доступ</h3>
            <div className="card-grid">
              <Link to="/planner" className="card quick-card">
                <div className="card-icon">📅</div>
                <h3 className="card-title">Планер</h3>
                <p className="card-description">
                  Организуй свои дела, ставь цели и следи за прогрессом
                </p>
                <div className="card-stats">
                  <span className="stat-item">📝 Задачи на день</span>
                  <span className="stat-item">🎯 Цели и мечты</span>
                  <span className="stat-item">💰 Финансы</span>
                </div>
              </Link>

              <Link to="/health" className="card quick-card">
                <div className="card-icon">💗</div>
                <h3 className="card-title">Здоровье</h3>
                <p className="card-description">
                  Отслеживай цикл, самочувствие и веди здоровый образ жизни
                </p>
                <div className="card-stats">
                  <span className="stat-item">🌸 Женское здоровье</span>
                  <span className="stat-item">💧 Питание и вода</span>
                  <span className="stat-item">😊 Настроение</span>
                </div>
              </Link>

              <Link to="/self-development" className="card quick-card">
                <div className="card-icon">✨</div>
                <h3 className="card-title">Саморазвитие</h3>
                <p className="card-description">
                  Читай книги, изучай новое и развивайся каждый день
                </p>
                <div className="card-stats">
                  <span className="stat-item">📚 Обучение</span>
                  <span className="stat-item">🎨 Творчество</span>
                  <span className="stat-item">💪 Личностный рост</span>
                </div>
              </Link>
            </div>
          </div>

          <div className="recent-activity">
            <h3 className="section-title">Недавняя активность</h3>
            <div className="activity-list">
              <div className="activity-item">
                <div className="activity-icon">📅</div>
                <div className="activity-content">
                  <h4>Планер</h4>
                  <p>Последний раз использовался: сегодня</p>
                </div>
              </div>
              <div className="activity-item">
                <div className="activity-icon">💗</div>
                <div className="activity-content">
                  <h4>Здоровье</h4>
                  <p>Отслеживайте свое самочувствие</p>
                </div>
              </div>
              <div className="activity-item">
                <div className="activity-icon">✨</div>
                <div className="activity-content">
                  <h4>Саморазвитие</h4>
                  <p>Начните свой путь к лучшей версии себя</p>
                </div>
              </div>
            </div>
          </div>

          <div className="features-section">
            <h3 className="section-title">Особенности приложения</h3>
            <div className="features-grid">
              <div className="feature-item">
                <div className="feature-icon">📱</div>
                <h4 className="feature-title">Адаптивный дизайн</h4>
                <p className="feature-description">
                  Удобно на любом устройстве - телефоне, планшете или компьютере
                </p>
              </div>

              <div className="feature-item">
                <div className="feature-icon">🎨</div>
                <h4 className="feature-title">Красивый интерфейс</h4>
                <p className="feature-description">
                  Нежный и стильный дизайн, который вдохновляет каждый день
                </p>
              </div>

              <div className="feature-item">
                <div className="feature-icon">🔒</div>
                <h4 className="feature-title">Конфиденциальность</h4>
                <p className="feature-description">
                  Все твои данные остаются приватными и защищенными
                </p>
              </div>

              <div className="feature-item">
                <div className="feature-icon">⚡</div>
                <h4 className="feature-title">Быстро и просто</h4>
                <p className="feature-description">
                  Интуитивно понятный интерфейс без лишних сложностей
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default HomePage;
